import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const paragraph_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path fill="none" stroke={iconColor} d="M4,5.5 L20,5.5 M4,9.5 L20,9.5 M4,13.5 L20,13.5 M4,17.5 L13,17.5" />
    </svg>
  );
};
